<template>
    <div>
        <el-table
                height="940"
                :data="jgsData"
                style="width: 100%"
                :highlight-current-row="highlightrow"
                @row-click="rowClick"
                :header-cell-style="{background:'#eef1f6',color:'#000'}">
            <el-table-column
                    prop="vc_name"
                    label="加工公司">
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import * as API from "./api"
    export default {
        name: "ProcessList",
        components: {},
        props: {
            processlist: {
                type: Object,
                required: true,
            }
        },
        data(){
            return{
                jgsData:[
                    {vc_name:"公司一"},
                    {vc_name:"公司er"}
                ],
                highlightrow:true,

            }
        },

        mounted() {
        },

        methods:{
            //点击某行加工公司
            rowClick(row){
                // console.log(row,"当前行公司数据");
                this.$emit('swichComdata',row)  //传到父组件entrust
            },
            //获取公司列表接口
            async getCompanyList(){
                let param={
                    i_mid:this.mid,
                    i_type:1,
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    this.jgsData=res.data;
                    // console.log(this.jgsData,"this.jgsData")
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>